import { clearLocalGameSnapshot } from './gameLocalStorage';
import { clearScoreboardSession } from '../leaderboard/scoreboardStorage';
import { clearPassPlayPlayers } from '../passPlayCreate/passPlayStorage';

const STARTER_PREFIX = 'nc_lastStarter_';
const PENDING_LOCAL_RESET = 'pendingLocalGameReset';
const PENDING_STARTING_PLAYER = 'pendingStartingPlayer';
const LOBBY_REMATCH_PENDING = 'scoreboardLobbyRematchPending';

/** Normalize category ids from UI / sessionStorage to a single key. */
export function normalizeCategoryMode(mode) {
  const m = String(mode ?? '').trim();
  if (!m) return '';
  if (m === 'vs-ai') return 'ai';
  if (m === 'pass-play' || m === 'passplay') return 'Pass & Play';
  return m;
}

export function readStoredCategoryMode() {
  try {
    return normalizeCategoryMode(sessionStorage.getItem('gameMode'));
  } catch {
    return '';
  }
}

/** Drop saved boards, scoreboard, timers, rematch flags, and alternate-starter keys. */
export function clearGameSessionForCategorySwitch() {
  clearLocalGameSnapshot('ai');
  clearLocalGameSnapshot('Pass & Play');
  clearScoreboardSession();
  clearPassPlayPlayers();

  for (const key of [
    PENDING_LOCAL_RESET,
    PENDING_STARTING_PLAYER,
    LOBBY_REMATCH_PENDING,
  ]) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }

  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(STARTER_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }
}

/**
 * Persist selected category; clear prior mode data when the category changes.
 * @returns {{ previousMode: string, nextMode: string, didClear: boolean }}
 */
export function switchGameCategory(nextMode) {
  const next = normalizeCategoryMode(nextMode);
  const prev = readStoredCategoryMode();
  const didClear = Boolean(prev && prev !== next);

  if (didClear) {
    clearGameSessionForCategorySwitch();
  }

  try {
    sessionStorage.setItem('gameMode', next);
  } catch {
    /* ignore */
  }

  return { previousMode: prev, nextMode: next, didClear };
}
